import _defineProperty from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _isObject from "lodash/fp/isObject";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { createElement } from 'react';
import TitleBlockWrapper, { TitleDescription } from './Wrapper';
export { TitleBlockWrapper, TitleDescription };

var TitleBlock = function TitleBlock(_ref) {
  var level = _ref.level,
      title = _ref.title,
      titleRef = _ref.titleRef,
      description = _ref.description,
      descriptionRef = _ref.descriptionRef,
      otherProps = _objectWithoutProperties(_ref, ["level", "title", "titleRef", "description", "descriptionRef"]);

  if (!title && !description) return null;
  var h = /*#__PURE__*/createElement("h".concat(level || 1), _objectSpread(_objectSpread(_objectSpread({}, typeof title === 'string' && {
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), _isObject(title) && {
    children: title
  }), {}, {
    ref: titleRef
  }));
  return __jsx(TitleBlockWrapper, otherProps, title && h, description && __jsx(TitleDescription, {
    ref: descriptionRef,
    dangerouslySetInnerHTML: {
      __html: description
    }
  }));
};

export default TitleBlock;